import { requestHandler } from "../lib/utils/network-client";

export function getEditableModule(moduleKey) {
  return requestHandler(`/${moduleKey}`);
}

export function updateEditableModule(moduleKey, payload) {
  return requestHandler(`/${moduleKey}`, {
    method: "PUT",
    body: payload
  });
}
